import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-monitor-fill",
  "use": "icon-monitor-fill-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-monitor-fill\">\n<path d=\"M10.8334 13.1111C10.3445 13.1111 9.90002 12.7999 9.72224 12.3111C9.72224 12.2666 9.72224 12.2222 9.6778 12.2222H5.72224C5.72224 12.2666 5.72224 12.3111 5.6778 12.3111C5.54446 12.7999 5.10002 13.1111 4.61113 13.1111C4.34446 13.1111 4.16669 13.2888 4.16669 13.5555C4.16669 13.8222 4.34446 13.9999 4.61113 13.9999H10.8334C11.1 13.9999 11.2778 13.8222 11.2778 13.5555C11.2778 13.2888 11.1 13.1111 10.8334 13.1111Z\" fill=\"currentColor\" />\n<path d=\"M12.6111 2H2.83333C2.07778 2 1.5 2.57778 1.5 3.33333V10C1.5 10.7556 2.07778 11.3333 2.83333 11.3333H5.9H9.5H12.6111C13.3667 11.3333 13.9444 10.7556 13.9444 10V3.33333C13.9444 2.57778 13.3667 2 12.6111 2Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/monitor-fill.svg
// module id = rdHh
// module chunks = 262